var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.item)?_c('section',{staticClass:"dd-m-carousel dd-m-carousel--top-banner",class:{'dd-m-hide' : !_vm.show}},[_c('div',[_c('div',{staticClass:"dd-m-carousel__slider"},[_c('card-quiz-offline',{attrs:{"item":_vm.item}})],1)])]):_vm._e()}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-08b29c6c","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/site/js/components/banners/banner-quiz-offline.vue
// module id = 575
// module chunks = 3